import styled from 'styled-components';
import { Layout } from 'antd';

const { Sider } = Layout;

export const MenuContainer = styled(Sider)`
  background-color: ${props => props.theme.palette.common.white};
  border-right: 1px solid ${props => props.theme.palette.border};
  top: -1px; // no border menu bellow header

  .ant-layout-sider-trigger {
    background-color: #D40511;
  }
`;
